export default {
  async reset({ commit }) {
    commit('reset')
  },

  resume({ commit }, payload) {
    commit('set', payload)
  },

  async set({ commit, getters, dispatch }, payload) {
    let track = payload ? getters.all.find(x => x.id === payload) : getters.all[0]
    commit('set', {
      current: JSON.parse(JSON.stringify(track)),
      selected: track.id,
      editResponsesMode: false,
      editingFollowupResponses: false,
    })
    dispatch('v4/session/start', {}, { root: true })
  },

  async clear({ commit, state, getters }) {
    if (state.selected) {
      let track = getters.all.find(x => x.id === state.selected)
      commit('set', { current: JSON.parse(JSON.stringify(track)), selected: track.id })
    }
  },

  async initializeStreamlinedOptions({ commit, dispatch, getters }) {
    const classifications = getters.classifications
    const panelResponses = await dispatch('v4/panel/responses', { version: 4 }, { root: true })
    const bundle = [...classifications, ...panelResponses]
    const streamlinedOptions = await dispatch('v4/mrx/streamlinedOptions', bundle, { root: true })
    const responses = streamlinedOptions.map((tile, index) => {
      return {
        id: tile.name,
        name: `streamlined.${tile.name}`,
        value: tile.name,
        ordering: index*100,
        selected: tile.preselect,
        preselect: tile.preselect,
      }
    })

    commit('set', { streamlinedOptions: responses })
  },

  async setStreamlinedTrack({ commit, dispatch, getters }) {
    const streamlinedSelections = getters.selectedStreamlinedOptions
    let data = { comprehensive: true, thresholdSet: null }
    if (streamlinedSelections.length > 0) {
      const classifications = getters.classifications.reduce((acc, cur) => {
        acc[cur.name] = cur.value
        return acc
      }, {})
      const payload = { classifications, streamlinedSelections }
      data = await dispatch('v4/mrx/streamlinedEvaluation', payload, { root: true })
    }
    commit('setTrackForStreamlined', data)
  }
}
